export const CookieKeys = {
  Token: 'Token',
  RefreshToken: 'RefreshToken'
};

const getBaseUrl = () => {
  // Tự động nhận diện thiết bị để chọn API Endpoint phù hợp nhất
  if (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
    return 'http://localhost:4000'; // Dành cho lập trình viên test trực tiếp trên máy tính local (siêu nhanh)
  }

  let envUrl = process.env.REACT_APP_BASE_URL;
  if (!envUrl) return 'https://api.tridoanhhr.vn';
  envUrl = envUrl.replace('admin.tridoanhhr.vn', 'api.tridoanhhr.vn');
  return envUrl.replace(/\/api\/?$/, '');
};

export const BASE_API_URL = `${getBaseUrl()}/api`;
